// extracted by mini-css-extract-plugin
export default {"portfolioBanner":"PortfolioBanner_portfolioBanner__rCiy-"};